import { Paper, Typography, Chip, Stack, Divider } from "@mui/material";

const ProblemDescription = ({ question, currentQuestion }) => (
  <Paper
    sx={{
      height: "100%",
      bgcolor: "#ffffff",
      color: "#333",
      p: 3,
      overflowY: "auto",
      borderRadius: 2,
    }}
  >
    <Typography
      variant="h5"
      fontWeight="600"
      gutterBottom
      style={{ display: "flex", gap: 5 }}
    >
      {currentQuestion}.
      <span
        dangerouslySetInnerHTML={{
          __html: question?.question_en,
        }}
      />
    </Typography>
    <Stack direction="row" spacing={1} mb={2}>
      <Chip
        label={question?.type}
        size="small"
        sx={{
          bgcolor: "#4caf5022",
          color: "#388e3c",
        }}
        // style={{
        //   textTransform: "capitalize",
        // }}
      />
      {/* <Chip
        label="String"
        size="small"
        variant="outlined"
        sx={{ color: "#8a8a8a" }}
      /> */}
    </Stack>
    <Divider sx={{ mb: 2, borderColor: "#e0e0e0" }} />
    {/* <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
      Given a binary string <b>s</b> without leading zeros, return{" "}
      <code>true</code> if <b>s</b> contains at most one contiguous segment of
      ones. Otherwise, return <code>false</code>.
      
    </Typography> */}
    <Typography>
      <span
        dangerouslySetInnerHTML={{
          __html: question?.description_en,
        }}
      />
    </Typography>
  </Paper>
);

export default ProblemDescription;
